import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-reminders-list-header',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './reminders-list-header.component.html',
    styleUrls: ['./reminders-list-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemindersListHeaderComponent {

}
